export default class LISSTimetableStructure {
    code: string;
    year: number;
    startDate: Date;
    endDate: Date;

    constructor(data?: Partial<LISSTimetableStructure>) {
        if (!!data) {
            Object.assign(this, data);

            this.startDate = data.startDate?.toDate();
            this.endDate = data.endDate?.toDate();
        }
    }
}
